import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/index'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput } from 'components/FormElements/ReduxForm'
import { Button, BUTTON_LAYOUTS } from 'components/UI'

// types
interface IIncomingProps {
  hideModal: () => void
}

interface IFormData {
  name: string
}

type IFormProps = InjectedFormProps<IFormData, IIncomingProps>

type IProps = IIncomingProps & IFormProps

const ReportForm: React.FC<IProps> = ({ handleSubmit, hideModal }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        size={{
          md: 12
        }}>
        <ReduxInput name={'name'} label={'Name'} />
      </Grid>
      <Grid container spacing={2} style={{ marginTop: '16px' }}>
        <Grid>
          <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} shadowLess>
            Save
          </Button>
        </Grid>
        <Grid>
          <Button type={'button'} onClick={hideModal} layout={BUTTON_LAYOUTS.PURPLE_INVERTED} shadowLess>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default reduxForm<IFormData, IIncomingProps>({
  form: Forms.REPORT_UPDATE_FORM,
  enableReinitialize: true
})(ReportForm)
